export default __webpack_public_path__ + "static/how-to-design-a-web-app-or-site-for-insurance-company-9c8c222d020bb1fc7dbabb15c7696975.png";